import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "../cookies_popup/cookies_popup.module.css";
import inactivityLogoutPopupStyles from "./inactivityLogoutPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";

function InactivityLogoutPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <button
        className={`${popupStyles.popup__closeBtn} hover`}
        onClick={onClose}
      />
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={popupStyles.popup__img}
      />
      <p dir={i18n.dir()}
        className={`${popupStyles.popup__title} ${popupStyles.popup__title_small} ${inactivityLogoutPopupStyles.popup__title}`}
      >
        {t('LOGOUT_DUE_TO_INACTIVITY')}</p>
      <p dir={i18n.dir()}
        className={`${popupStyles.popup__text} ${inactivityLogoutPopupStyles.popup__text}`}
      >
        {t('LOGOUT_AUTOMATICALLY')}{" "}
      </p>
      <Link
        to={"/login"}
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t('RETURN_TO_SITE')}</Link>
    </article>
  );
}

export default InactivityLogoutPopup;
